import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const Terms = () => {
  return (
    <main className="min-h-screen bg-slate-50">
      {/* Header */}
      <section className="bg-white border-b border-slate-100">
        <div className="max-w-4xl mx-auto px-6 md:px-12 py-12 md:py-16">
          <Link to="/" className="inline-flex items-center gap-2 text-slate-600 hover:text-slate-900 mb-6" data-testid="terms-back-link">
            <ArrowLeft className="h-4 w-4" />
            Înapoi
          </Link>
          <h1 className="font-display text-3xl md:text-4xl font-bold text-slate-900" data-testid="terms-title">
            Termeni și condiții
          </h1>
          <p className="text-slate-600 mt-2">Ultima actualizare: Ianuarie 2026</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-12 md:py-16">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-8 md:p-12">
            <div className="prose prose-slate max-w-none">
              <h2 className="font-display text-xl font-semibold text-slate-900 mt-0">
                1. Dispoziții generale
              </h2>
              <p className="text-slate-600 leading-relaxed">
                Prezentele Termeni și Condiții guvernează utilizarea serviciilor oferite 
                de AnDeni Time Solutions SRL (denumită în continuare "Compania", "noi" sau "noastră"), 
                o societate comercială înregistrată în România.
              </p>
              <p className="text-slate-600 leading-relaxed">
                Prin accesarea și utilizarea serviciilor noastre, sunteți de acord să respectați 
                și să fiți obligat de acești termeni. Dacă nu sunteți de acord cu oricare dintre 
                acești termeni, vă rugăm să nu utilizați serviciile noastre.
              </p>

              <h2 className="font-display text-xl font-semibold text-slate-900 mt-8">
                2. Serviciile oferite
              </h2>
              <p className="text-slate-600 leading-relaxed">
                AnDeni Time Solutions oferă servicii de intermediere pentru documente auto 
                și acte oficiale, incluzând dar nelimitându-se la:
              </p>
              <ul className="text-slate-600 space-y-2">
                <li>Emitere contracte de vânzare-cumpărare auto</li>
                <li>Radiere auto de la taxe locale și poliție</li>
                <li>Declarare la taxe locale</li>
                <li>Asistență pentru înmatriculări și reînmatriculări</li>
                <li>Servicii complete tip pachet (Gold, Gold Plus, Platinum)</li>
              </ul>

              <h2 className="font-display text-xl font-semibold text-slate-900 mt-8">
                3. Prețuri și plăți
              </h2>
              <p className="text-slate-600 leading-relaxed">
                Toate prețurile afișate pe website includ exclusiv costurile serviciilor 
                de intermediere oferite de Companie. Taxele oficiale percepute de instituțiile 
                de stat sunt separate și vor fi comunicate clientului înainte de procesarea dosarului.
              </p>
              <p className="text-slate-600 leading-relaxed">
                Plata serviciilor se face conform modalităților convenite cu clientul. 
                Compania își rezervă dreptul de a solicita un avans pentru anumite servicii.
              </p>

              <h2 className="font-display text-xl font-semibold text-slate-900 mt-8">
                4. Responsabilitate
              </h2>
              <p className="text-slate-600 leading-relaxed">
                Compania își asumă responsabilitatea pentru corectitudinea și legalitatea 
                serviciilor prestate, în limita informațiilor și documentelor furnizate 
                de client.
              </p>
              <p className="text-slate-600 leading-relaxed">
                Clientul este responsabil pentru:
              </p>
              <ul className="text-slate-600 space-y-2">
                <li>Furnizarea de informații corecte și complete</li>
                <li>Punerea la dispoziție a documentelor necesare în original sau copie conform cerințelor</li>
                <li>Informarea Companiei cu privire la orice modificări relevante</li>
              </ul>

              <h2 className="font-display text-xl font-semibold text-slate-900 mt-8">
                5. Termene de livrare
              </h2>
              <p className="text-slate-600 leading-relaxed">
                Termenele de procesare a dosarelor depind de complexitatea serviciului 
                și de timpii de răspuns ai instituțiilor publice. Compania va face 
                eforturi rezonabile pentru a respecta termenele estimate, dar nu poate 
                garanta termene fixe din cauza factorilor externi.
              </p>

              <h2 className="font-display text-xl font-semibold text-slate-900 mt-8">
                6. Forța majoră
              </h2>
              <p className="text-slate-600 leading-relaxed">
                Compania nu va fi responsabilă pentru întârzieri sau imposibilitatea 
                de a îndeplini obligațiile cauzate de evenimente de forță majoră, 
                incluzând dar nelimitându-se la: calamități naturale, greve, modificări 
                legislative, defecțiuni ale sistemelor informatice ale instituțiilor publice.
              </p>

              <h2 className="font-display text-xl font-semibold text-slate-900 mt-8">
                7. Soluționarea litigiilor
              </h2>
              <p className="text-slate-600 leading-relaxed">
                Orice litigiu apărut între Companie și client va fi soluționat pe cale 
                amiabilă. În cazul în care nu se ajunge la o înțelegere, litigiul va fi 
                supus spre soluționare instanțelor competente din România.
              </p>

              <h2 className="font-display text-xl font-semibold text-slate-900 mt-8">
                8. Modificări ale termenilor
              </h2>
              <p className="text-slate-600 leading-relaxed">
                Compania își rezervă dreptul de a modifica acești termeni în orice moment. 
                Modificările vor fi publicate pe website și vor intra în vigoare de la 
                data publicării. Utilizarea continuă a serviciilor după publicarea 
                modificărilor constituie acceptarea noilor termeni.
              </p>

              <h2 className="font-display text-xl font-semibold text-slate-900 mt-8">
                9. Contact
              </h2>
              <p className="text-slate-600 leading-relaxed">
                Pentru orice întrebări legate de acești Termeni și Condiții, ne puteți 
                contacta la:
              </p>
              <ul className="text-slate-600 space-y-1">
                <li>Email: office@andeni-inmatriculari.ro</li>
                <li>Telefon: +40 700 000 000</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Terms;
